import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { merge } from 'lodash';
import * as categoryTRTypes from './categoryTRTypes';

const byId = handleActions(
  {
    [categoryTRTypes.CATEGORY_TR_LIST.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.categoriesTR),
  },
  {},
);

const allIds = handleActions(
  {
    [categoryTRTypes.CATEGORY_TR_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
